import React from 'react';
import styled from 'styled-components';

const ReadOnlyField = ({ content, operator }) => {
  const ReadOnlyTextField = styled.div`
    display: flex;
    border: 2px solid #e3e3e3;
    border-radius: 4px;
    margin-right: 10px;
    text-align: center;
    background-color: ${operator ? '#e3e3e3' : 'white'};
    align-items: center;
    justify-content: center;
    z-index: 1;
    min-height: 36px;
    min-width: 68px;
    white-space: pre;
    padding: 0 10px;
  `;

  return (
    <ReadOnlyTextField>
      <span>{content}</span>
    </ReadOnlyTextField>
  );
};

export default ReadOnlyField;
